import { render } from "./CustomTable.vue?vue&type=template&id=5a3081dc&scoped=true"
import script from "./CustomTable.vue?vue&type=script&lang=js"
export * from "./CustomTable.vue?vue&type=script&lang=js"

import "./CustomTable.vue?vue&type=style&index=0&id=5a3081dc&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3081dc"]])

export default __exports__